// Cross-bundle "can the active viewer reach this ground container?" capability.
// Presentation-independent: reads retained FT3D encounter/caster data directly.

import {
    encounterCreatureField,
    inventoryField,
} from '../../shared/array-types';
import { proximityWithinReach } from '../../shared/proximity';
import { actorCanReachTarget } from '../../shared/proximity-browser';

const sizeFeet = (id: string): number | null => {
    const size = SIZE_TYPES.find(entry => entry.item_id.toUpperCase() === id)?.base_size;
    return typeof size === 'number' && Number.isFinite(size) ? size : null;
};

export function activeViewerCanReach(targetArr: unknown): boolean | null {
    if (typeof ftIsModifyEncounterToolsPage === 'function' && ftIsModifyEncounterToolsPage()) return true;
    const encounterId = String(window.ftGetActiveEncounterId?.() ?? '').trim();
    if (!encounterId || !checkIfValidUUID(encounterId)) return true;

    const state = window.FateTide;
    const viewerId = String(state?.activeViewerCasterId ?? '').trim();
    if (!viewerId && activeViewerIsFullGm()) return true;
    const casterId = viewerId || String(window.ftGetActiveCasterId?.() ?? '').trim();
    if (!casterId) return null;
    const caster = state?.casterCache?.get(casterId) ?? null;
    if (!caster) return null;

    const possessId = String(inventoryField(targetArr, 'possess_id') ?? '').toUpperCase();
    if (!possessId || possessId !== encounterId.toUpperCase()) return true;
    const ownerId = String(encounterCreatureField(
        (caster as { encounter_creatures?: unknown }).encounter_creatures,
        'encounter_creature_id',
    ) ?? '').toUpperCase();
    if (possessId === ownerId) return true;

    return proximityWithinReach(caster, targetArr, sizeFeet);
}

export function activeViewerIsFullGm(): boolean {
    if (typeof ftIsModifyEncounterToolsPage === 'function' && ftIsModifyEncounterToolsPage()) return true;
    const state = window.FateTide;
    const surface = document.querySelector<HTMLElement>('[data-ft-encounter-surface][data-can-edit="true"][data-can-use-entity-actions="true"]');
    const encounterEditor = !!surface && surface.dataset.encounterId?.toUpperCase() === String(window.ftGetActiveEncounterId?.() ?? '').toUpperCase();
    return (encounterEditor || state?.user?.isGM === true) && !String(state?.activeViewerCasterId ?? '').trim();
}

declare global {
    interface Window {
        ftActiveViewerCanReach?: (targetArr: unknown) => boolean | null;
        ftActiveViewerIsFullGm?: () => boolean;
        ftActorCanReachTarget?: (actorId: string, targetId: string) => Promise<boolean | null>;
    }
}

window.ftActiveViewerCanReach = activeViewerCanReach;
window.ftActiveViewerIsFullGm = activeViewerIsFullGm;
window.ftActorCanReachTarget = actorCanReachTarget;
